import script from "./index-web.vue?vue&type=script&lang=ts&setup=true"
export * from "./index-web.vue?vue&type=script&lang=ts&setup=true"

import "./style/index.scss?vue&type=style&index=0&id=36081489&lang=scss&scoped=true&external"
import "./index-web.vue?vue&type=style&index=1&id=36081489&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36081489"]])

export default __exports__